var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 9.875C8.625 7.4625 10.5875 5.5 13 5.5C15.4125 5.5 17.375 7.4625 17.375 9.875C17.375 11.85 16.05 13.5037 14.25 14.0462V15.5C14.25 16.1912 13.6912 16.75 13 16.75C12.3088 16.75 11.75 16.1912 11.75 15.5V13C11.75 12.3088 12.3088 11.75 13 11.75C14.0338 11.75 14.875 10.9088 14.875 9.875C14.875 8.84125 14.0338 8 13 8C11.9662 8 11.125 8.84125 11.125 9.875C11.125 10.5662 10.5662 11.125 9.875 11.125C9.18375 11.125 8.625 10.5662 8.625 9.875ZM11.75 19.25C11.75 18.5588 12.3088 18 13 18C13.6912 18 14.25 18.5588 14.25 19.25C14.25 19.9412 13.6912 20.5 13 20.5C12.3088 20.5 11.75 19.9412 11.75 19.25ZM13 23C7.48625 23 3 18.5138 3 13C3 7.48625 7.48625 3 13 3C18.5138 3 23 7.48625 23 13C23 18.5138 18.5138 23 13 23ZM13 0.5C6.1075 0.5 0.5 6.1075 0.5 13C0.5 19.8925 6.1075 25.5 13 25.5C19.8925 25.5 25.5 19.8925 25.5 13C25.5 6.1075 19.8925 0.5 13 0.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.424d3a0e8a45ebec067ee57976638956.svg";
export { ForwardRef as ReactComponent };